// extracted by mini-css-extract-plugin
export default {"confirmation-dialog__text":"style_confirmation-dialog__text__cZzyH","confirmation-dialog__controls":"style_confirmation-dialog__controls__mYX6u"};